(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ce-slab-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ce-slab-guards')) return;

    const HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

    const buttonText = (btn) => {
      for (const n of btn.childNodes) {
        if (n.nodeType === 3 && n.textContent.trim()) return n;
      }
      return null;
    };

    class SlabGuard extends HTMLElement {
      connectedCallback() {
        this.swatches = [...this.querySelectorAll('.ce-guard__swatch')];
        this.previewImg = this.querySelector('[data-ref="previewImg"]');
        this.selectedName = this.querySelector('[data-ref="selectedName"]');
        this.selectedPrice = this.querySelector('[data-ref="selectedPrice"]');
        this.variantInput = this.querySelector('input[name="id"]');
        this.addButton = this.querySelector('button[type="submit"]');
        this.addText = this.addButton ? buttonText(this.addButton) : null;
        this.addLabel = this.addText ? this.addText.textContent.trim() : '';
        this.soldOutLabel = this.closest('ce-slab-guards')?.dataset.soldOut || 'Sold out';
        this.selected = this.swatches.find((s) => s.getAttribute('aria-checked') === 'true') || this.swatches[0];

        this.swatches.forEach((s) => {
          s.addEventListener('click', () => this.select(s));
          s.addEventListener('keydown', (e) => this.onKey(e, s));
          if (HOVER.matches) {
            s.addEventListener('pointerenter', () => this.peek(s));
            s.addEventListener('pointerleave', () => this.unpeek());
          }
          s.addEventListener('focus', () => this.peek(s));
          s.addEventListener('blur', () => this.unpeek());
        });
        this.querySelector('[data-action="open"]')?.addEventListener('click', () => {
          this.closest('ce-slab-guards')?.openDialog(this);
        });
        // Horizon's add-to-cart-component re-enables its button as it boots,
        // so the sold-out state is re-applied after that has happened
        requestAnimationFrame(() => setTimeout(() => this.select(this.selected, { silent: true }), 0));
      }

      get selectedSwatch() {
        return this.selected;
      }

      swapImage(img, src) {
        if (!img || !src || img.dataset.current === src) return;
        img.classList.add('is-swapping');
        const next = new Image();
        next.onload = () => {
          img.src = src;
          img.srcset = '';
          img.dataset.current = src;
          img.classList.remove('is-swapping');
        };
        next.src = src;
      }

      // Hover only drives the popover. The row photo shows the SELECTED colour
      // and nothing else - swapping it on hover made it flicker as the pointer
      // crossed the strip, with the popover showing the same thing anyway.
      peek(s) {
        if (HOVER.matches) this.closest('ce-slab-guards')?.showPop(s);
      }

      unpeek() {
        this.closest('ce-slab-guards')?.hidePop();
      }

      select(s, { silent } = {}) {
        this.selected = s;
        this.swatches.forEach((x) => {
          const on = x === s;
          x.setAttribute('aria-checked', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
        });
        this.swapImage(this.previewImg, s.dataset.img);
        if (this.selectedName) this.selectedName.textContent = s.dataset.title;
        if (this.selectedPrice) this.selectedPrice.textContent = s.dataset.price;
        if (this.variantInput) this.variantInput.value = s.dataset.variantId;
        const available = s.dataset.available === 'true';
        if (this.addButton) {
          this.addButton.disabled = !available;
          if (this.addText) this.addText.textContent = available ? this.addLabel : this.soldOutLabel;
        }
        if (!silent) this.closest('ce-slab-guards')?.syncDialog(this);
      }

      onKey(e, s) {
        const i = this.swatches.indexOf(s);
        let j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % this.swatches.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + this.swatches.length) % this.swatches.length;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); this.select(s); return; }
        if (j === null) return;
        e.preventDefault();
        this.swatches[j].focus();
        this.select(this.swatches[j]);
      }

      submit() {
        if (this.addButton && !this.addButton.disabled) this.addButton.click();
      }
    }

    class SlabGuards extends HTMLElement {
      connectedCallback() {
        this.pop = this.querySelector('[data-ref="pop"]');
        this.popImg = this.querySelector('[data-ref="popImg"]');
        this.popName = this.querySelector('[data-ref="popName"]');
        this.dialog = this.querySelector('[data-ref="dialog"]');
        this.dialogImg = this.querySelector('[data-ref="dialogImg"]');
        this.dialogFamily = this.querySelector('[data-ref="dialogFamily"]');
        this.dialogTitle = this.querySelector('[data-ref="dialogTitle"]');
        this.dialogLine = this.querySelector('[data-ref="dialogLine"]');
        this.dialogSwatches = this.querySelector('[data-ref="dialogSwatches"]');
        this.dialogAdd = this.querySelector('[data-ref="dialogAdd"]');
        this.activeRow = null;
        // fixed positioning breaks under any transformed ancestor, and the
        // product column has a few, so the popover lives on <body>
        if (this.pop && this.pop.parentElement !== document.body) document.body.appendChild(this.pop);

        this.querySelector('[data-action="close"]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        this.dialogAdd?.addEventListener('click', () => {
          this.dialog?.close();
          this.activeRow?.submit();
        });
        window.addEventListener('scroll', () => this.hidePop(), { passive: true });
      }

      showPop(s) {
        if (!this.pop || !s.dataset.img) return;
        this.popImg.src = s.dataset.img;
        this.popName.textContent = s.dataset.title + (s.dataset.available === 'true' ? '' : ' · ' + (this.dataset.soldOut || 'Sold out'));
        this.pop.hidden = false;
        const r = s.getBoundingClientRect();
        const w = 200;
        const h = 236;
        let left = r.left + r.width / 2 - w / 2;
        left = Math.max(8, Math.min(left, window.innerWidth - w - 8));
        let top = r.top - h - 10;
        if (top < 8) top = r.bottom + 10;
        this.pop.style.left = left + 'px';
        this.pop.style.top = top + 'px';
        requestAnimationFrame(() => this.pop.classList.add('is-open'));
      }

      hidePop() {
        if (!this.pop) return;
        this.pop.classList.remove('is-open');
        this.pop.hidden = true;
      }

      openDialog(row) {
        if (!this.dialog) return;
        this.activeRow = row;
        this.hidePop();
        this.dialogFamily.textContent = row.dataset.name;
        if (this.dialogLine) this.dialogLine.textContent = row.querySelector('.ce-guard__blurb')?.textContent || '';
        // rebuild the strip from the row's swatches so both stay in step
        this.dialogSwatches.innerHTML = '';
        this.dialogSwatches.className = 'ce-guard__swatches ce-guard__swatches--dialog';
        this.dialogSwatches.classList.toggle('ce-guard__type--jewel', row.dataset.family === 'jewel');
        row.swatches.forEach((s) => {
          const b = s.cloneNode(true);
          b.addEventListener('click', () => {
            row.select(s, { silent: true });
            this.syncDialog(row);
          });
          if (HOVER.matches) {
            b.addEventListener('pointerenter', () => this.swapDialogImage(s.dataset.imgLarge || s.dataset.img));
            b.addEventListener('pointerleave', () => this.swapDialogImage(row.selectedSwatch.dataset.imgLarge || row.selectedSwatch.dataset.img));
          }
          this.dialogSwatches.appendChild(b);
        });
        this.syncDialog(row);
        this.dialog.showModal();
      }

      swapDialogImage(src) {
        if (!this.dialogImg || !src || this.dialogImg.dataset.current === src) return;
        this.dialogImg.classList.add('is-swapping');
        const next = new Image();
        next.onload = () => {
          this.dialogImg.src = src;
          this.dialogImg.dataset.current = src;
          this.dialogImg.classList.remove('is-swapping');
        };
        next.src = src;
      }

      syncDialog(row) {
        if (!this.dialog || this.activeRow !== row) return;
        const s = row.selectedSwatch;
        this.swapDialogImage(s.dataset.imgLarge || s.dataset.img);
        this.dialogTitle.textContent = s.dataset.title;
        [...this.dialogSwatches.children].forEach((b, i) => {
          b.setAttribute('aria-checked', row.swatches[i] === s ? 'true' : 'false');
        });
        const available = s.dataset.available === 'true';
        this.dialogAdd.disabled = !available;
        this.dialogAdd.textContent = available
          ? (this.dataset.addTemplate || 'Add %c · %p').replace('%c', s.dataset.title).replace('%p', s.dataset.price)
          : (this.dataset.soldOut || 'Sold out');
      }
    }

    customElements.define('ce-slab-guard', SlabGuard);
    customElements.define('ce-slab-guards', SlabGuards);
  })();
  } catch(e) { console.error(e); }
})();

})();
